import styled from 'styled-components';

const FlexMatchSettingsDialogStyles = styled.div`
  min-width: 320px;
  padding-top: 24px;

  table {
    border-spacing: 8px;
    margin: -8px;

    th:first-child,
    td:first-child {
      padding-right: 10px;
      width: 150px;
      line-height: 16px;
      position: relative;
    }
    .warning-icon {
      position: absolute;
      top: 50%;
      left: -8px;
      transform: translate(-100%, -50%);
      font-size: 15px;
    }
  }

  &.has-agencies {
    padding-top: 0;

    table {
      margin: 0;
      padding: 0 8px 0 15px;
    }

    .preference-planunit-settings,
    .all-planunit-settings {
      margin-bottom: 30px;
    }
  }

  .preference-planunit-settings {
    margin-bottom: 30px;
  }

  .external-settings {
    .table-wrapper {
      max-height: 248px;
    }
  }

  .chip {
    padding: 0 8px;

    &.selected {
      color: white;
    }

    .MuiChip-label {
      padding: 0;
    }

    & + .chip {
      margin-left: 8px;
    }
  }

  .email-field {
    margin-top: 20px;
  }

  .info-cell {
    position: relative;
    width: 10px;

    .info-icon {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      left: 0;
      font-size: 13px;
    }
  }
`;

export default FlexMatchSettingsDialogStyles;
